import ReactDOM from 'react-dom';
import StudentOverlay from './StudentOverlay'
import type { StudentOverlayData } from './StudentOverlay'

interface StudentOverlayPortalProps {
  thisStudent: StudentOverlayData;
  containerId: string;
  isHighlighted?: boolean;
  onDelete: (elementId: string) => void;
  onLockToggle?: (memberId: string) => void;
}

const StudentOverlayPortal = ({ thisStudent, containerId, isHighlighted, onDelete, onLockToggle }: StudentOverlayPortalProps) => {
    const container = document.getElementById(containerId);

    if (!container) return null;

    // StudentOverlay liest alles aus thisStudentOverlay — die früher zusätzlich
    // übergebenen Einzelfelder (day, startTime, …) existierten dort nie als Props.
    return ReactDOM.createPortal(<StudentOverlay
      isHighlighted={isHighlighted}
      thisStudentOverlay={thisStudent}
      onDelete={onDelete}
      onLockToggle={onLockToggle}
      />, container);
  };

  export default StudentOverlayPortal;
